import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import PasswordInput from "../../components/PasswordInput";
import { StrengthIndicatorContext } from "../../shared/contexts/StrengthIndicatorContext";
import { validatePswMatch, validatePswStrength } from "../../shared/utils/set-psw-form-error-rules";
import { Typography } from "@mui/material";
import { useStyles } from "../../components/StrengthIndicator/StrengthIndicator.styles";
import FormLayoutHeader from "../../layoutComponents/FormLayout/FormLayoutHeader";

const SetPassword = () => {
    const [strengthIndicator, setStrengthIndicator] = useState<string | null>("Síla hesla");

    const {
        formState: { errors },
        control,
        watch,
    } = useFormContext();
    const styles = useStyles();

    return (
        <div>
            <StrengthIndicatorContext.Provider value={{ strengthIndicator, setStrengthIndicator }}>
                <FormLayoutHeader title="Nové heslo" />

                <Typography>Délka hesla musí být minimálně 10 znaků.</Typography>
                <Typography gutterBottom>Použijte velká a malá písmena, číslice a speciální znaky (např.: @, !, %, *, #, $, ?, &, _, ^).</Typography>
                    <div className={styles.newPassWrap}>
                        <PasswordInput
                            name="password"
                            validator={validatePswStrength}
                            defaultValue=""
                            label={
                                <Typography component="span" variant="inherit" className={styles.float}>
                                    Heslo
                                </Typography>
                            }
                            control={control}
                            watch={watch}
                            errors={errors}
                            tabValue={1}
                            showPasswordIndicator={true}
                        />
                    </div>

                    <PasswordInput
                        name="passwordAgain"
                        validator={validatePswMatch}
                        defaultValue=""
                        label="Heslo znovu"
                        watch={watch}
                        control={control}
                        errors={errors}
                        tabValue={2}
                        showPasswordIndicator={false}
                    />
            </StrengthIndicatorContext.Provider>
        </div>
    );
};

export default SetPassword;
